module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [(_vm.fill_info == '' && _vm.subpage == 'open') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("Kitöltési útmutató")]), _vm._v(" "), _c('PerfectScrollbar', {
    staticStyle: {
      "height": "50vh",
      "border": "1px solid #f4f4f4",
      "padding": "20px 20px 0px 20px",
      "margin-bottom": "20px"
    },
    attrs: {
      "options": {
        wheelPropagation: false,
        handlers: ['click-rail', 'drag-thumb', 'keyboard', 'wheel', 'touch']
      }
    }
  }, [_c('div', {
    staticClass: "article-text medium"
  }, [_c('p', [_vm._v("Tisztelt Ösztöndíjas!")]), _vm._v(" "), _c('p', [_vm._v("Az Új Nemzeti Kiválóság Program (továbbiakban: ÚNKP) keretein belül a Pályázati Kiírásoknak megfelelően minden ösztöndíjas számára kötelező a kutatási időszaka végén a pályázatában vállalt kutatásáról "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("Szakmai Záró Beszámoló")]), _vm._v("t (továbbiakban: Beszámoló) és annak részeként "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("Témavezetői Szakmai Értékelés")]), _vm._v("t (továbbiakban: Értékelés) benyújtani a megfelelő igazolásokkal együtt.")]), _vm._v(" "), _c('p', [_vm._v("A Beszámolót a Széchenyi István Egyetem (továbbiakban: Egyetem) ÚNKP bíráló bizottsága fogja értékelni Kiváló, Megfelelt és Nem megfelelt minősítéssel.")]), _vm._v(" "), _c('p', [_vm._v("Amennyiben az Egyetem a Beszámolót nem fogadja el, Nem megfeleltre értékeli, vagy az ösztöndíjas nem nyújtja be azt a megadott határidőig, az Egyetem az ösztöndíjas számára visszafizetési kötelezettséget állapít meg.")]), _vm._v(" "), _c('p', [_vm._v("Minden esetben a "), _c('span', {
    staticClass: "highlight"
  }, [_c('u', [_vm._v("KTR felületen kérjük véglegesíteni a Beszámolót")])]), _vm._v(". Ezt követően az ÚNKP felelősök ellenőrzik az anyagot, és esetlegesen hiánypótlási felhívást intéznek az Ösztöndíjas felé. A hiánypótlás csak papíralapon lehetséges. "), _c('span', {
    staticClass: "highlight"
  }, [_c('u', [_vm._v("Akár szükséges hiánypótlás, akár nem, a teljes anyag papíralapú leadása egy előzetes, emailen történő időpontegyeztetés után az Igazgatási Épület (SZE Győr) 101-es irodájában történik, ahol az "), _c('i', [_vm._v("eredeti")]), _vm._v(", aláírt Beszámolót, Értékelést, Konzultációs lapot, és a Beszámolóhoz tartozó összes "), _c('i', [_vm._v("mellékletet")])])]), _vm._v(" kérjük benyújtani.")]), _vm._v(" "), _c('p', [_vm._v("A "), _c('span', {
    staticClass: "highlight"
  }, [_c('u', [_vm._v("mellékletek tetejére minden esetben kérjük ráírni a melléklet számát és az elnevezését")])]), _vm._v(". Amennyiben a mellékletek "), _c('span', {
    staticClass: "highlight"
  }, [_c('u', [_vm._v("másolati példányok, kérjük ráírni, hogy „Az eredetivel mindenben megegyező hiteles másolat.” és aláírni azt")])]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("A "), _c('span', {
    staticClass: "highlight"
  }, [_c('u', [_vm._v("Kutatási Terv")])]), _vm._v(" a beadott pályázati anyag részét képezi. A Beszámolóhoz elegendő egy másolati példány benyújtása, ami a pályázati felhívás kapcsán már a folyamat elején is feltöltésre került a KTR rendszerbe.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "highlight"
  }, [_vm._v("Kitöltési segédlet:")])]), _vm._v(" "), _c('ul', {
    staticClass: "ordered-list with-icon",
    staticStyle: {
      "padding-bottom": "20px"
    }
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v("A "), _c('u', [_vm._v("Záró Beszámolók közül")]), _vm._v(" a vonatkozó ösztöndíjas kategória szerinti sablont kérjük kiválasztani.")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v("A "), _c('u', [_vm._v("Témavezetői Értékelést")]), _vm._v(" – a fejlécet kitöltve – kérjük eljuttatni a témavezetőhöz, majd a Beszámoló részeként, kitöltve kérjük "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("feltölteni a KTR rendszerbe mind szerkeszthető mind pdf formában")]), _vm._v(".")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v("Az "), _c('u', [_vm._v("1-5 pontot")]), _vm._v(" kérjük röviden kifejteni, de a "), _c('span', {
    staticClass: "highlight"
  }, [_c('u', [_vm._v("Beszámoló teljes terjedelme ne legyen több 3 oldalnál")])]), _vm._v(".")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v("A "), _c('u', [_vm._v("2/a. pontnál")]), _vm._v(" kérjük leírni, hogy az ÚNKP intézményi keret terhére történt-e egyéni keretfelhasználás.\n            "), _c('br'), _vm._v("-\tHa nem történt beszerzés, akkor kérjük, ne kerüljön semmi sem a 2/a. ponthoz.\n            "), _c('br'), _vm._v("-\tHa történt beszerzés, kérjük megadni milyen jellegű volt, hogyan került felhasználásra az ÚNKP kutatás során (1-1mondat) a beszerzett tétel, illetve beszerzésnél az anyagok/eszközök egyetemi leltárba kerültek e vagy fogyóeszköznek minősültek.\n            "), _c('br'), _c('br'), _c('i', [_vm._v("Példák 2/a ponthoz:")]), _vm._v(" "), _c('br'), _vm._v("- Könyvbeszerzés: pl.: Saltelli, A, Chan, K., Scott, E. M.: Sensitivity Analysis, 2008, John Wiley & Sons Ltd. – kutatásom során fontos szakirodalom, egyetemi leltárba került\n            "), _c('br'), _vm._v("- Konferenciarészvétel: 15th Miklós Iványi International Phd&Dla Symposium, Pécs, 28-29.10.2019. – szabadon választott vállalás\n            "), _c('br'), _vm._v("- Eszközbeszerzés: HDD 2,5\" Portable 2TB USB3.1 külső merevlemez - kutatásom során a feldolgozott szakirodalmat és az elkészített szimulációkat tároltam rajta, egyetemi leltárba került\n            "), _c('br'), _vm._v("- Anyagbeszerzés: csillag villáskulcs plusz egyéb laboratóriumi eszközök, melyek fogyóeszköznek minősülnek.\n            ")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('u', [_vm._v("A 3. ponthoz")]), _vm._v(" kerüljenek a beszámolóba a már benyújtott, de még el nem fogadott kéziratok is, amiket számszerűen a 7. pontnál kérünk feltüntetni.")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v("A "), _c('u', [_vm._v("6. pontban")]), _vm._v(" az intézményen belüli kötelező vállalásokhoz szükséges nyilatkozatok szerepelnek. Kérjük, "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("ne javítsa a sablon szövegét")]), _vm._v(", és a 2023. június 30., valamint a 2023. augusztus 31-ig tartó ösztöndíjas jogviszony esetén legyen kedves aláhúzni, hogy melyik napon tartott előadást az ÚNKP konferencián.")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('u', [_vm._v("7. pontnál")]), _vm._v(" "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("minden cella kitöltése szükséges, a 0-ákat is feltüntetve")]), _vm._v(".")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v("A "), _c('u', [_vm._v("Mellékletek")]), _vm._v(": "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("Elnevezésük")]), _vm._v(" minden esetben a következő legyen: melléklet száma, elnevezése, saját neve. Pl.: 1.sz. melléklet Kutatási Terv Vezetékneve Keresztneve")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v("A "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("Beszámoló 1-5. pontjainál")]), _vm._v(" is tüntesse fel a hozzá tartozó melléklet "), _c('u', [_vm._v("számát")]), _vm._v(".")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v("A kötelező mellékletek után "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("folytassa a felsorolást és számozást")]), _vm._v(" (szakirodalom feldolgozások, megjelent, elfogadott cikkek, konferenciaelőadások, TDK dolgozat, MTMT lista, stb, illetve "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("papír alapon kicsinyítve")]), _vm._v(" (1 lapon 2 oldal jelenjen meg) 2 oldalasan "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("nyomtassa")]), _vm._v(" ki a cikkeket, előadásokat.")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v("A 6. ponthoz nem szükséges mellékelni semmit sem, ezt központilag az Intézményi Beszámolóban fogjuk igazolni.")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _vm._v("A "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("KTR-be")]), _vm._v(", legyen kedves az "), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("eredeti dokumentumokat")]), _vm._v(" feltölteni.")]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-angle-right"
  }), _c('span', {
    staticClass: "highlight"
  }, [_vm._v("Papír alapú leadáskor")]), _vm._v(" az oklevelek, igazolások másolati példányra legyen kedves ráírni, hogy „Az eredetivel mindenben megegyező hiteles másolat.” és aláírni azt, illetve minden melléklet tetején jelölje a melléklet Beszámolóban megadott számát és elnevezését.")])]), _vm._v(" "), _c('p', [_vm._v("Köszönettel és üdvözlettel,"), _c('br'), _vm._v("ÚNKP felelősök")])])]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.subpage = 'data'
      }
    }
  }, [_vm._v("Tovább")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.fill_info == '' && _vm.subpage == 'data') ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "nev",
      "label": "Viselt neve <span style='font-size: 10px; display: block; font-weight: 400'>(A dr-i, egyéb nevére vonatkozó előtagokat, a neve után vesszővel elválasztva tüntesse fel)</span>",
      "name": "nev",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ. ,]+",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.nev),
      callback: function($$v) {
        _vm.form.nev = $$v
      },
      expression: "form.nev"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "email",
      "label": "E-mail cím <span style='font-size: 10px; display: block; font-weight: 400'>(Pályázat beadásakor megadott)</span>",
      "name": "email",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.form.email = $$v
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('inputbox', {
    attrs: {
      "id": "mobilszam",
      "label": "Mobilszám",
      "mask": "+99 99 / 999 9999",
      "regexp_filter": "[0-9]+",
      "name": "mobilszam",
      "errors": _vm.errors
    },
    model: {
      value: (_vm.form.mobilszam),
      callback: function($$v) {
        _vm.form.mobilszam = $$v
      },
      expression: "form.mobilszam"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "errors": _vm.errors,
      "id": "szakmai_zaro_beszamolo_szerkesztheto",
      "label": "Szakmai Záró Beszámoló szerkeszthető változat <span style='font-size: 10px; display: block; font-weight: 400'>(A fájl elnevezése az ösztöndíjas előtagok nélküli neve és ÚNKP Záró Szakmai Beszámoló_szerk. legyen.)</span>",
      "name": "szakmai_zaro_beszamolo_szerkesztheto",
      "loaded_files": _vm.form.szakmai_zaro_beszamolo_szerkesztheto
    },
    on: {
      "change": function (value) {
        _vm.form.szakmai_zaro_beszamolo_szerkesztheto = value;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "szakmai_zaro_beszamolo",
      "label": "Szakmai Záró Beszámoló aláírva, szkennelve <span style='font-size: 10px; display: block; font-weight: 400'>(A fájl elnevezése az ösztöndíjas előtagok nélküli neve és ÚNKP Záró Szakmai Beszámoló legyen.)</span>",
      "name": "szakmai_zaro_beszamolo",
      "loaded_files": _vm.form.szakmai_zaro_beszamolo
    },
    on: {
      "change": function (value) {
        _vm.form.szakmai_zaro_beszamolo = value;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "errors": _vm.errors,
      "id": "temavezetoi_szakmai_ertekeles_szerkesztheto",
      "label": "Témavezetői Szakmai Értékelés szerkeszthető változat <span style='font-size: 10px; display: block; font-weight: 400'>(A fájl elnevezése az ösztöndíjas előtagok nélküli neve és ÚNKP Témavezetői Szakmai Értékelés_szerk. legyen.)</span>",
      "name": "temavezetoi_szakmai_ertekeles_szerkesztheto",
      "loaded_files": _vm.form.temavezetoi_szakmai_ertekeles_szerkesztheto
    },
    on: {
      "change": function (value) {
        _vm.form.temavezetoi_szakmai_ertekeles_szerkesztheto = value;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "temavezetoi_szakmai_ertekeles",
      "label": "Témavezetői Szakmai Értékelés aláírva, szkennelve <span style='font-size: 10px; display: block; font-weight: 400'>(A fájl elnevezése az ösztöndíjas előtagok nélküli neve és ÚNKP Témavezetői Szakmai Értékelés legyen.)</span>",
      "name": "temavezetoi_szakmai_ertekeles",
      "loaded_files": _vm.form.temavezetoi_szakmai_ertekeles
    },
    on: {
      "change": function (value) {
        _vm.form.temavezetoi_szakmai_ertekeles = value;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "konzultacios_lap",
      "label": "Konzultációs lap aláírva, szkennelve <span style='font-size: 10px; display: block; font-weight: 400'>(A fájl elnevezése az ösztöndíjas előtagok nélküli neve és ÚNKP Konzultációs lap legyen.)</span>",
      "name": "konzultacios_lap",
      "loaded_files": _vm.form.konzultacios_lap
    },
    on: {
      "change": function (value) {
        _vm.form.konzultacios_lap = value;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "kutatasi_terv",
      "label": "Kutatási terv aláírva, szkennelve <span style='font-size: 10px; display: block; font-weight: 400'>(A pályázat beadásakor (alapképzés esetén szeptemberben) leadott eredeti, aláírt Kutatási Terv), (A fájl elnevezése az ösztöndíjas előtagok nélküli neve és ÚNKP Kutatási terv legyen.)</span>",
      "name": "kutatasi_terv",
      "loaded_files": _vm.form.kutatasi_terv
    },
    on: {
      "change": function (value) {
        _vm.form.kutatasi_terv = value;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "10",
      "accepted_files": "image/jpeg,application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "id": "mellekletek",
      "label": "Mellékletek <span style='font-size: 10px; display: block; font-weight: 400'>(A melléklet elnevezése, száma a Szakmai Záró Beszámoló pontjai szerint. Doktori hallgatói-, doktorjelölt kategóriánál az MTMT lista kötelező melléklet. A 6. pont teljesítését központilag az Intézményi Szakmai Beszámolóban fogjuk igazolni.)</span>",
      "name": "mellekletek",
      "loaded_files": _vm.form.mellekletek
    },
    on: {
      "change": function (value) {
        _vm.form.mellekletek = value;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_vm._l((_vm.form.melleklet_urlek), function(url, i) {
    return _c('div', {
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "margin-bottom": "5px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.melleklet_urlek[i]),
        expression: "form.melleklet_urlek[i]"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Külső Url (pl.: http://webcim.hu/dokumentum.pdf)"
      },
      domProps: {
        "value": (_vm.form.melleklet_urlek[i])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          var $$exp = _vm.form.melleklet_urlek,
            $$idx = i;
          if (!Array.isArray($$exp)) {
            _vm.form.melleklet_urlek[i] = $event.target.value
          } else {
            $$exp.splice($$idx, 1, $event.target.value)
          }
        }
      }
    }), _vm._v(" "), _c('a', {
      staticClass: "button only-icon v2",
      staticStyle: {
        "margin-left": "5px"
      },
      attrs: {
        "href": _vm.form.melleklet_urlek[i],
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    })]), _vm._v(" "), _c('button', {
      staticClass: "button only-icon",
      staticStyle: {
        "margin-left": "5px"
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.deleteUrl(i)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    })])])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "margin-bottom": "20px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.uj_melleklet_url),
      expression: "uj_melleklet_url"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Külső Url (pl.: http://webcim.hu/dokumentum.pdf)"
    },
    domProps: {
      "value": (_vm.uj_melleklet_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.uj_melleklet_url = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button only-icon v2",
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addUrl
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.saving,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.save(1)
      }
    }
  }, [_vm._v("Mentés")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": _vm.saving,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.save(2)
      }
    }
  }, [_vm._v("Véglegesít")])])])]) : _vm._e(), _vm._v(" "), (_vm.fill_info != '') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("ÚNKP Szakmai Záró Beszámoló")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.fill_info)
    }
  })])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v("Adatok")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "info-box download",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "assets/files/szakmai-zaro-beszamolo-alapkepzes-sablon-22-10.docx",
      "title": "Szakmai záró beszámoló alapképzés sablon letöltés"
    }
  }, [_c('span', {
    staticClass: "highlight"
  }, [_vm._v("Szakmai záró beszámoló alapképzés sablon")]), _vm._v(" letöltés\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "info-box download",
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "assets/files/szakmai-zaro-beszamolo-mesterkepzes-sablon-22-10.docx",
      "title": "Szakmai záró beszámoló mesterképzés sablon letöltés"
    }
  }, [_c('span', {
    staticClass: "highlight"
  }, [_vm._v("Szakmai záró beszámoló mesterképzés sablon")]), _vm._v(" letöltés\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "info-box download"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "assets/files/temavezetoi-szakmai-ertekeles-22-10.docx",
      "title": "Témavezetői szakmai értékelés sablon letöltés"
    }
  }, [_c('span', {
    staticClass: "highlight"
  }, [_vm._v("Témavezetői szakmai értékelés sablon")]), _vm._v(" letöltés\n          ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9420d7f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/competition/unkp_beszamolo_22_10.vue
// module id = 394
// module chunks = 0